import { useEffect, useId, useState } from 'react';
import { Dialog } from './Dialog';
import { loadYaml, type YamlContent, type YamlSlug } from '../../utils/yamlLoader';

interface LegalModalProps {
  slug: YamlSlug | null;
  onClose: () => void;
}

const FALLBACK_TITLES: Record<YamlSlug, string> = {
  kontakt: 'Kontakt',
  rechtliches: 'Rechtliches',
  datenschutz: 'Datenschutz',
  impressum: 'Impressum',
};

interface LoadState {
  slug: YamlSlug;
  content?: YamlContent;
  error?: string;
}

/** Zeigt Legal-Texte (Kontakt, Rechtliches, Datenschutz, Impressum) aus YAML-Dateien in einem Dialog. */
export function LegalModal({ slug, onClose }: LegalModalProps) {
  const titleId = useId();
  const [result, setResult] = useState<LoadState | null>(null);

  useEffect(() => {
    if (!slug) return;

    let cancelled = false;

    loadYaml(slug)
      .then((data) => {
        if (!cancelled) setResult({ slug, content: data });
      })
      .catch((err: unknown) => {
        console.error(err);
        if (!cancelled) {
          setResult({ slug, error: 'Die Inhalte konnten nicht geladen werden.' });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  const loaded = slug && result?.slug === slug ? result : undefined;
  const loading = slug !== null && !loaded;
  const title = slug ? (loaded?.content?.title ?? FALLBACK_TITLES[slug]) : '';

  return (
    <Dialog open={slug !== null} onClose={onClose} titleId={titleId} title={title}>
      {loading && <p>Wird geladen…</p>}
      {loaded?.error && <p className="legal-modal__error">{loaded.error}</p>}
      {loaded?.content && <div className="legal-modal__text">{loaded.content.text}</div>}
    </Dialog>
  );
}
